import React from 'react';
import cx from 'classnames';

import styles from './inputs.module.scss';

const SelectField = ({ meta, input, label, subLabel, children, variant }) => {
  const hasError = meta.submitFailed && meta.error;
  const placeholder = input.placeholder || label.toLowerCase();
  const { variant: variantProp } = input;
  const variantStr = variant || variantProp;

  const inputClasses = cx(styles.input, input.className, {
    [styles.selectWithPlaceholder]: !input.value,
    [styles.inputError]: hasError,
  });

  const labelClasses = cx(styles.label, {
    [styles.labelError]: hasError,
    [styles.labelStandalone]: variantStr === 'standalone',
  });

  const selectWrapperClasses = cx(styles.selectWrapper, {
    [styles.selectWrapperStandalone]: variantStr === 'standalone',
  });

  const id = input.id || input.name;

  return (
    <div className={styles.inputWrapper}>
      <label htmlFor={id} className={labelClasses}>
        {label}
      </label>

      <div className={selectWrapperClasses}>
        <select {...input} id={id} className={inputClasses}>
          {placeholder && (
            <option disabled value="">
              {placeholder}
            </option>
          )}
          {children}
        </select>
        {subLabel && <p className={styles.subLabel}>{subLabel}</p>}
      </div>
      {hasError && <p className={styles.errorMsg}>{meta.error}</p>}
    </div>
  );
};

export default SelectField;
